export default "__VITE_ASSET__DuL0jJ5h__"